import { render, staticRenderFns } from "./tab2.vue?vue&type=template&id=58736347&scoped=true"
import script from "./tab2.vue?vue&type=script&lang=js"
export * from "./tab2.vue?vue&type=script&lang=js"
import style0 from "./tab2.vue?vue&type=style&index=0&id=58736347&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58736347",
  null
  
)

export default component.exports